import PayType from "../../../../utilities/data/model/PayType";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { Text } from "@towersystems/roam-common-native";

const getObservables = ({ payType }: { payType: PayType }) => ({
  payType: payType.observe(),
});

export interface PayTypeDetailsTextProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {
  payType: PayType;
}

const PayTypeDetailsTextRenderer = ({ payType }: PayTypeDetailsTextProps) => {
  return <Text color="subdued">{payType.name}</Text>;
};

const enhance = withObservables(["payType"], getObservables);

export const PayTypeDetailsText = enhance(PayTypeDetailsTextRenderer);
